import { useMutation } from '@apollo/client';
import { CREATE_STUDIO_CREATIVE } from '../../graphql/mutations/creativeMutations';

/**
 * Hook to create a link between a Studio and a Creative
 * @returns {object} - { handleCreateStudioCreative, loading, error }
 */
export const useCreateStudioCreative = () => {
  const [createStudioCreativeMutation, { loading, error }] = useMutation(CREATE_STUDIO_CREATIVE, {
    refetchQueries: [
      'StudioCreativesByStudioID', 
      'StudioCreativesByCreativeID',
      'GetStudio',
      'GetCreative'
    ],
    awaitRefetchQueries: true
  });

  const sanitizeInput = (input = {}) => {
    const cleaned = { ...input };
    Object.keys(cleaned).forEach((key) => {
      if (cleaned[key] === undefined || cleaned[key] === null) {
        delete cleaned[key];
      }
    });
    return cleaned;
  };

  const handleCreateStudioCreative = async (linkData) => {
    try {
      if (!linkData?.studioID) {
        throw new Error('Das Studio konnte nicht zugeordnet werden. Bitte lade die Seite neu und versuche es erneut.');
      }

      if (!linkData?.creativeID) {
        throw new Error('Das Creative-Profil konnte nicht zugeordnet werden. Bitte lade die Seite neu und versuche es erneut.');
      }

      const input = sanitizeInput({
        studioID: linkData.studioID,
        creativeID: linkData.creativeID
      });

      const { data: linkResponse } = await createStudioCreativeMutation({
        variables: { input }
      });

      return linkResponse?.createStudioCreative;
    } catch (error) {
      console.error('Error creating studio-creative link:', error);
      throw error;
    }
  };

  return {
    handleCreateStudioCreative,
    loading,
    error
  };
};
